import type React from 'react';

import { InstantSearch } from 'react-instantsearch';

import { Spinner } from '@change/ds-core-ui';

import { ClientRender } from '@change-corgi/core/react/ssr/render';

import { MaintenanceContainer } from '../components/MaintenanceContainer';
import { PageBody } from '../components/PageBody';
import { PageMeta } from '../components/PageMeta';
import { ResetFiltersOnSamePageNavigation } from '../components/ResetFiltersOnSamePageNavigation';

import { useLayout } from './hooks/useLayout';
import { useTrackPageView } from './hooks/useTrackPageView';
import { useUnderMaintenance } from './hooks/useUnderMaintenance';

export const LayoutInner: React.FC = () => {
	const {
		data: { searchClient, routing, instantSearchIndexName },
	} = useLayout();

	return (
		<InstantSearch
			indexName={instantSearchIndexName}
			searchClient={searchClient}
			routing={routing}
			future={{
				// This allow us to preserve the state of the widgets when the component is unmounted
				// eg: when the new modal is closed
				preserveSharedStateOnUnmount: true,
			}}
		>
			<PageBody />
			<ResetFiltersOnSamePageNavigation />
		</InstantSearch>
	);
};

export const Layout: React.FC = () => {
	useTrackPageView();

	const {
		data: { isUnderMaintenance },
	} = useUnderMaintenance();

	if (isUnderMaintenance) {
		return <MaintenanceContainer />;
	}

	return (
		<>
			<PageMeta />
			<ClientRender placeholder={<Spinner className="mx-auto my-64" />}>
				<LayoutInner />
			</ClientRender>
		</>
	);
};
